import * as React from 'react';
import './bank-account-statement.scss';
import { Page } from 'components/page/page';
import { Card } from 'components/card/card';
import { Table } from 'components/table/table';
import { BankAccountStatementChargeStatus, BankAccountStatementType, Enum } from 'core/domain';
import { Badge, Modal } from 'components';
import { useNavigate } from 'react-router-dom';
import { Button, buttonType } from 'components/button/button';
import { Input } from 'components/input/input';
import { PaginationList } from '../../../../core/domain/commons/common';
import { detect_bank, formatCardNumber } from 'core/utils/bankDetecter';
import moment from 'jalali-moment';
import {
    confirmAndPayoutBankAccountStatement,
    getAllBankAccountStatementChargeStatusTypes,
    getAllBankAccountStatements,
    getAllBankAccountStatementTypes,
} from '../../../../core/repositories/bank-account-statement';
import DatePicker from 'react-multi-date-picker';
import persian from 'react-date-object/calendars/persian';
import persian_fa from 'react-date-object/locales/persian_fa';
import { digitSperator, faNumToEnNum } from '../../../../core/utils/decimalExtentions';
import { ReactComponent as CalendarIcon } from 'assets/icons/dash-line-icons/calendar.svg';
import { CopyOutlined, DollarCircleOutlined, DownOutlined, InfoCircleOutlined } from '@ant-design/icons';
import { copyToClipboard } from '../../../../core/utils/copyToClipboard';
import { Dropdown } from '../../../../components/dropdown/dropdown';
import { Dropdown as AntdDropdown, Menu } from 'antd';
import { OrderDetailModal } from '../orders/order-detail/order-detail';
import { getPageNum } from '../../../../core/utils/paggingHelper';
import { ConfirmBankAccountStatementBulkSelectModal } from './bulk-select-modal/bulk-select-modal';
import { jFormat } from 'core/utils/jFormat';

interface FilterValues {
    search: string;
    startDate: string;
    endDate: string;
    chargeStatus: Enum;
    type: Enum;
}

const empty_filters = {
    search: '',
    chargeStatus: {
        id: -1,
        title: 'وضعیت واریز',
    },
    type: {
        id: -1,
        title: 'نوع',
    },
    endDate: '',
    startDate: '',
};

export const BankAccountStatement: React.FC = () => {
    const [bankStatements, setBankStatements] = React.useState<PaginationList<BankAccountStatementType>>();
    const [loading, setLoading] = React.useState<boolean>(false);
    const [buttonLoading, setButtonLoading] = React.useState<boolean>(false);

    const [deleteButtonLoading, setDeleteButtonLoading] = React.useState<boolean>(false);
    const [filterValues, setFilterValues] = React.useState<FilterValues>(empty_filters);
    const [query, setQuery] = React.useState<string>('');
    const [chargeStatusTypes, setChargeStatusTypes] = React.useState<Enum[]>([
        {
            id: -1,
            title: 'وضعیت شارژ',
        },
    ]);

    const [bankAccountStatement, setBankAccountStatement] = React.useState<Enum[]>([
        {
            id: -1,
            title: 'نوع',
        },
    ]);

    const actionItems: Enum[] = [
        {
            id: 0,
            title: 'انتخاب عملیات',
        },
        {
            id: 100,
            title: 'تایید و تسویه',
        },
    ];
    const [selectedRows, setSelectedRows] = React.useState<BankAccountStatementType[]>();
    const [confirmBulkActionModalIsOpen, setConfirmBulkActionModalIsOpen] = React.useState<boolean>(false);
    const [actionApproveLoading, setActionApproveLoading] = React.useState<boolean>(false);
    const [selectedActionItem, setSelectedActionItem] = React.useState<Enum>(actionItems[0]);
    const [payoutModalIsOpen, setPayoutModalIsOpen] = React.useState<boolean>(false);
    const [confirmButtonLoading, setConfirmButtonLoading] = React.useState<boolean>(false);
    const [selectedItem, setSelectedItem] = React.useState<BankAccountStatementType>();

    const [detailModalIsOpen, setDetailModalIsOpen] = React.useState<boolean>(false);

    const [pageSize, setPageSize] = React.useState<number>(10);

    const navigate = useNavigate();
    const startDateRef = React.useRef(null);
    const endDateRef = React.useRef(null);

    const clearFiltersHandle = () => {
        setFilterValues(empty_filters);
        filterHandle(true);
    };
    const onInfoIconClickHandle = (item) => {
        console.log(item);
        setSelectedItem(item);
        setDetailModalIsOpen(true);
    };
    const onPayoutIconClickHandle = (item) => {
        setSelectedItem(item);
        setPayoutModalIsOpen(true);
    };
    const filterHandle = (clearFilter?: boolean) => {
        var _query = '';

        if (filterValues.search) _query += `${_query.includes('?') ? '&' : '?'}keyword=${filterValues.search}`;
        if (filterValues.chargeStatus?.id !== -1)
            _query += `${_query.includes('?') ? '&' : '?'}chargeStatus=${filterValues.chargeStatus?.id}`;
        if (filterValues.type?.id !== -1) _query += `${_query.includes('?') ? '&' : '?'}type=${filterValues.type?.id}`;
        if (filterValues.startDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}startDate=${jFormat(filterValues.startDate)}`;
        if (filterValues.endDate !== '')
            _query += `${_query.includes('?') ? '&' : '?'}endDate=${jFormat(filterValues.endDate)}`;

        setQuery(_query);
        getAllBankAccountStatements(
            clearFilter ? setDeleteButtonLoading : _query !== '' ? setButtonLoading : setLoading,
            setBankStatements,
            1,
            pageSize,
            clearFilter ? '' : _query,
        );
    };

    const openActionConfirmModal = () => {
        setActionApproveLoading(false);
        setConfirmBulkActionModalIsOpen(true);
    };
    React.useEffect(() => {
        setSelectedRows([]);
        filterHandle(false);
        getAllBankAccountStatementChargeStatusTypes(setLoading, setChargeStatusTypes);
        getAllBankAccountStatementTypes(setLoading, setBankAccountStatement);
    }, []);

    const columns: any[] = [
        {
            name: 'شماره کارت',
            id: 'cardNumber',
            selector: (row: BankAccountStatementType) => row.cardNumber,
            width: '15%',
            cell: (row: BankAccountStatementType) => (
                <span className="en copiable card-col">
                    {row.cardNumber !== null ? (
                        <>
                            <CopyOutlined onClick={() => copyToClipboard(row.cardNumber, 'شماره کارت')} />
                            {formatCardNumber(row?.cardNumber)}
                            {detect_bank(row.cardNumber) && (
                                <img
                                    width={16}
                                    height={16}
                                    alt={'Bank'}
                                    src={`/assets/images/banks/${detect_bank(row.cardNumber)?.bank_name}.svg`}
                                />
                            )}
                        </>
                    ) : (
                        '-'
                    )}
                </span>
            ),
        },
        {
            name: 'مبلغ',
            id: 'amount',
            selector: (row: BankAccountStatementType) => digitSperator(row.amount),
            width: '10%',
        },
        {
            name: 'توضیحات',
            id: 'description',
            selector: (row: BankAccountStatementType) => row.description,
            width: '7%',
        },
        {
            name: 'اطلاعات اضافی',
            id: 'additionalInformation',
            selector: (row: BankAccountStatementType) => row.additionalInformation,
            width: '7%',
        },

        {
            name: 'روش',
            id: 'transferType',
            width: '7%',
            selector: (row: BankAccountStatementType) => row.transferType.id,
            cell: (row: BankAccountStatementType) => (
                <Badge
                    text={row.transferType.title}
                    type={row.transferType.id === 2 ? 'error' : row.transferType.id === 3 ? 'waiting' : 'success'}
                />
            ),
        },
        {
            name: 'نوع',
            id: 'type',
            width: '5%',
            selector: (row: BankAccountStatementType) => row.type.id,
            cell: (row: BankAccountStatementType) => (
                <Badge
                    text={row.type.title}
                    type={row.type.id === 2 ? 'error' : row.type.id === 3 ? 'waiting' : 'success'}
                />
            ),
        },
        {
            name: 'تاریخ تراکنش',
            id: 'createdOn',
            selector: (row: BankAccountStatementType) => row?.date || '',
            sortable: true,
            cell: (row: BankAccountStatementType) => (
                <span>
                    {moment.utc(row?.date).locale('fa').local().format('YYYY/MM/DD')}{' '}
                    {moment.utc(row?.date).locale('fa').local().format('HH:mm')}
                </span>
            ),
        },
        {
            name: 'شماره شبای حساب',
            id: 'fullName',
            selector: (row: BankAccountStatementType) => row.sourceIBan,
            width: '15%',
        },
        {
            name: 'نام بانک',
            id: 'bankName',
            selector: (row: BankAccountStatementType) => row.bankName,
        },
        {
            name: 'وضعیت شارژ',
            id: 'chargeState',
            selector: (row: BankAccountStatementType) => row.chargeStatus,
            cell: (row: BankAccountStatementType) => (
                <Badge
                    text={row.chargeStatus.title}
                    type={
                        row?.chargeStatus?.title.includes('انجام شده')
                            ? 'success'
                            : row?.chargeStatus?.title.includes('پردازش نشده')
                                ? 'error'
                                : 'waiting'
                    }
                />
            ),
        },
        {
            name: 'عملیات',
            id: 'action',
            width: '10%',
            cell: (row: BankAccountStatementType) => (
                <div className="actions">
                    {row.chargeStatus.id != BankAccountStatementChargeStatus.Done && (
                        <DollarCircleOutlined onClick={() => onPayoutIconClickHandle(row)} />
                    )}
                    {row && row.chargeStatus.id == BankAccountStatementChargeStatus.Done && (
                        <InfoCircleOutlined onClick={() => onInfoIconClickHandle(row)} />
                    )}
                </div>
            ),
        },
        ,
    ];

    return (
        <Page className="pmx-bank-account-statement" title="همه صورت حساب های بانکی">
            {selectedItem && (
                <OrderDetailModal
                    selectedRow={selectedItem}
                    isOpen={detailModalIsOpen}
                    setIsOpen={setDetailModalIsOpen}
                    trackingId={selectedItem?.trackingCode}
                />
            )}
            <Modal setIsOpen={setPayoutModalIsOpen} isOpen={payoutModalIsOpen} className="confirm-payout-modal">
                <p>آیا از تایید و تسویه تراکنش کاربر {selectedItem?.cardNumber} اطمینان دارید؟</p>

                <div className="buttons">
                    <Button
                        type={buttonType.info}
                        text="بله"
                        onClick={() =>
                            confirmAndPayoutBankAccountStatement(
                                setConfirmButtonLoading,
                                { bankAccountStatementId: selectedItem?.id },
                                () => setPayoutModalIsOpen(false),
                                () => getAllBankAccountStatements(setLoading, setBankStatements, 1, pageSize, query),
                            )
                        }
                        loading={confirmButtonLoading}
                    />
                    <Button type={buttonType.error} text="خیر" onClick={() => setPayoutModalIsOpen(false)} />
                </div>
            </Modal>
            {selectedRows && (
                <ConfirmBankAccountStatementBulkSelectModal
                    isOpen={confirmBulkActionModalIsOpen}
                    setIsOpen={setConfirmBulkActionModalIsOpen}
                    buttonLoading={actionApproveLoading}
                    selectedActionItem={selectedActionItem}
                    selectedRows={selectedRows}
                    setButtonLoading={setActionApproveLoading}
                    setSelectedRows={setSelectedRows}
                    fetchData={async () => {
                        await getAllBankAccountStatements(setLoading, setBankStatements, getPageNum(), pageSize, query);
                    }}
                    actionItem={selectedActionItem}
                />
            )}
            <Card title="لیست صورت حساب های بانکی" blur={loading}>
                <div className="filter-row">
                    <div className="fields">
                        <Input
                            value={filterValues.search}
                            className="search"
                            placeholder="جستجو کنید ..."
                            onPressEnter={filterHandle}
                            name="search"
                            onChange={(e) => setFilterValues({ ...filterValues, search: e.target.value })}
                        />
                        {chargeStatusTypes.length > 0 && (
                            <Dropdown
                                items={chargeStatusTypes}
                                onChangeHandle={(value) =>
                                    setFilterValues({
                                        ...filterValues,
                                        chargeStatus: chargeStatusTypes.find((l) => l.id === value),
                                    })
                                }
                                selectedOption={filterValues.chargeStatus}
                            />
                        )}
                        {bankAccountStatement.length > 0 && (
                            <Dropdown
                                items={bankAccountStatement}
                                onChangeHandle={(value) => {
                                    console.log({ value });
                                    console.log(bankAccountStatement);
                                    console.log(bankAccountStatement.find((l) => l.id === value));
                                    setFilterValues({
                                        ...filterValues,
                                        type: bankAccountStatement.find((l) => l.id === value),
                                    });
                                }}
                                selectedOption={filterValues.type}
                            />
                        )}

                        <DatePicker
                            className="date-picker"
                            value={filterValues.startDate}
                            calendar={persian}
                            ref={startDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.startDate}
                                        icon={<CalendarIcon />}
                                        placeholder="از تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({ ...filterValues, startDate: e.format() });
                            }}
                        />
                        <DatePicker
                            className="date-picker"
                            value={filterValues.endDate}
                            calendar={persian}
                            ref={endDateRef}
                            locale={persian_fa}
                            render={
                                <div>
                                    <Input
                                        value={filterValues.endDate}
                                        icon={<CalendarIcon />}
                                        placeholder="تا تاریخ"
                                    />
                                </div>
                            }
                            onChange={(e) => {
                                setFilterValues({ ...filterValues, endDate: e.format() });
                            }}
                        />
                    </div>
                    <div className="buttons">
                        <Button
                            loading={buttonLoading}
                            disabled={buttonLoading}
                            text="اعمال فیلتر"
                            type={buttonType.success}
                            onClick={() => filterHandle()}
                        />
                        <Button
                            loading={deleteButtonLoading}
                            disabled={deleteButtonLoading}
                            text="حذف فیلتر"
                            type={buttonType.error}
                            onClick={clearFiltersHandle}
                        />
                    </div>
                </div>
                {selectedRows && selectedRows?.length > 1 && (
                    <div className="action-row">
                        <div className="fields">
                            <AntdDropdown
                                trigger={['click', 'hover']}
                                overlay={
                                    <Menu>
                                        {actionItems &&
                                            actionItems.map((state) => (
                                                <Menu.Item onClick={() => setSelectedActionItem(state)}>
                                                    {state.title}
                                                </Menu.Item>
                                            ))}
                                    </Menu>
                                }
                                placement="bottom"
                            >
                                <Button
                                    icon={<DownOutlined />}
                                    type={buttonType.outlined}
                                    text={selectedActionItem.title}
                                />
                            </AntdDropdown>
                        </div>
                        <div className="buttons">
                            <Button
                                disabled={selectedActionItem.id === 0}
                                type={buttonType.info}
                                text="اصلاح تراکنش‌های انتخاب شده"
                                onClick={() => openActionConfirmModal()}
                            />
                            <Button type={buttonType.outlined} text={`${selectedRows?.length} آیتم انتخاب شده`} />
                        </div>
                    </div>
                )}
                {bankStatements?.items && bankStatements?.items.length > 0 && (
                    <>
                        <Table
                            setPageSize={setPageSize}
                            blur={loading}
                            setloader={setLoading}
                            getdata={getAllBankAccountStatements}
                            setdata={setBankStatements}
                            pagination={bankStatements.pagination}
                            className="bank-accounts-table"
                            data={bankStatements.items}
                            column={columns}
                            filters={query}
                        // conditionalRowStyles={[
                        //     {
                        //         when: (row: BankAccountStatementType) =>
                        //             row?.chargeStatus?.id === BankAccountStatementChargeStatus.Done,
                        //         style: {backgroundColor: "#e0ffe0"},
                        //     },
                        //     {
                        //         when: (row: BankAccountStatementType) =>
                        //             row?.chargeStatus?.id === BankAccountStatementChargeStatus.NotProcessed,
                        //         style: {backgroundColor: "#ff000026"},
                        //     },
                        //     {
                        //         when: (row: BankAccountStatementType) =>
                        //             row?.chargeStatus?.id === BankAccountStatementChargeStatus.WaitingForConfirmation,
                        //         style: {backgroundColor: "#ffef0b4d"},
                        //     },
                        // ]}
                        // selectableRows
                        // onSelectRowsChange={(selected) => {
                        //     setSelectedRows(selected.selectedRows);
                        // }}
                        // clearSelectedRows={selectedRows?.length === 0 || !selectedRows}
                        />
                    </>
                )}
            </Card>
        </Page>
    );
};
